'use strict';

/**
 * 判断当前环境是否支持指定JS接口<br />
 * 使用场景：在不确定当前客户端对API支持情况下检测<br />
 * HY不支持的验证方法：config、ready、register、onShow、onHide、onReceiveData、onCloseWebView、onLoadingClose、onNavClick、openCashier、login、checkLogin、logout、getCaptchaUrl、getUserInfo<br />
 * 对应native接口：checkJsApi
 * @method hysdk.checkJsApi
 * @category Base
 * @example ./checkJsApi.js[1-12]
 * @description
 *
 * | 参数 | 类型 | 描述 | 必选 | 注明 |
 * | :--: | :--: | :--: | :--: | :--: |
 * | jsApiList | Array | 待检测的 api | √ | 常用参数 |
 * | success | Function | success 回调 | X | 常用参数 |
 * | fail | Function | fail 回调 | X | 常用参数 |
 *
 * | 运行环境  | 是否支持 |
 * | :-----: | :-----: |
 * | Hy      |    √    |
 * | Hy Browser (qunar) | √    |
 * | Hy Browser (非qunar) | √    |
 * | touch   |    √    |
 * | wechat  |    √    |
 * | ctrip   |   √   |
 *
 */
module.exports = {
    checkJsApi: {
        hy: function () {
            var name2KeyMap = {},
                key2NameMap = {};
            return {
                optHandle: function optHandle(opt) {
                    var _this = this;

                    opt.jsApiList = opt.jsApiList.map(function (item) {
                        if (!name2KeyMap[item]) {
                            var cf = _this._apis[item] && _this._apis[item].hy;
                            name2KeyMap[item] = cf && cf.key || item;
                            key2NameMap[name2KeyMap[item]] = item;
                        }
                        return name2KeyMap[item];
                    });
                    return opt;
                },
                resHandle: function resHandle(res) {
                    var checkResult = res.data || {},
                        rs = {};
                    for (var key in checkResult) {
                        if (key === 'webview.back') {
                            if (name2KeyMap.closeWebView) {
                                rs.closeWebView = true;
                            }
                            if (name2KeyMap.closeWindow) {
                                rs.closeWindow = true;
                            }
                        } else {
                            rs[key2NameMap[key]] = checkResult[key];
                        }
                    }
                    name2KeyMap = key2NameMap = {};
                    return rs;
                }
            };
        }(),
        wechat: {
            successHandle: function successHandle(res) {
                Object.keys(res.checkResult).forEach(function (key) {
                    if (key.indexOf('share') === 0) {
                        res.checkResult[key] = false;
                    }
                    if (key === 'onMenuShare') {
                        res.checkResult[key] = true;
                    }
                    if (key === 'log') {
                        res.checkResult[key] = false;
                    }
                });
                return res.checkResult;
            }
        },
        h5: {
            handle: function handle() {
                var opt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var sdk = arguments[1];

                var data = {};
                var jsApiList = opt.jsApiList || [];
                jsApiList.forEach(function (v) {
                    // h5暂时不支持事件，将所有事件都置为false
                    if (/^on[^Menu]|off/.test(v)) {
                        data[v] = false;
                    } else {
                        data[v] = !!sdk.h5[v];
                    }
                    return data[v];
                });
                opt.success(data);
            }
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ../src/apis/base.js
// module id = 11
// module chunks = 0 2 4